import { Pipe, PipeTransform } from '@angular/core';
import { ApplicationAppEntityApplicationRead } from '../openapi';

@Pipe({
  name: 'applicationNotesLabel',
  standalone: true
})
export class ApplicationNotesLabelPipe implements PipeTransform {
  transform(application?: ApplicationAppEntityApplicationRead | null): string {
    switch (true) {
      case application?.service?.url === '/lokalizacja-urzadzenia-niezwiazanego-z-funkcjonowaniem-drogi': {
        return 'Uzasadnienie umieszczenia';
      }
      default: {
        return 'Rodzaj zgłoszenia (np. czego dotyczy zgłoszenie - uszkodzenia czy braku oznakowania, itp.)';
      }
    }
  }
}
